<template>
	<div>
		<FormGroup
			label="Bitte wähle den nächsten Schritt aus"
			:label-classes="['font-weight-bold']"
		>
			<RadioGroup
				v-model="followUp"
				:options="followUpOptions"
				stacked
			/>
		</FormGroup>
		<MakeAppointment
			v-if="followUpAppointment"
			v-model="makeAppointmentData"
			:message="message"
			:action="actionFollowUpAppointment"
			class="mt-4"
			@success="$emit('processed')"
		/>
		<CustomerInterested
			v-if="followUpInterested"
			:message="message"
			class="mt-4"
			@processed="$emit('processed')"
		/>
		<CustomerSendOff
			v-if="followUpSendoff"
			v-model="sendOffData"
			:disclosed-data="message.disclosedData"
			:pseudonym="message.pseudonym"
			class="mt-3"
			:with-applicant-name="false"
		/>
		<div v-if="followUpSendoff" class="mt-3 text-right">
			<Button
				text="Senden"
				icon="checkmark"
				:disabled="!dataValid || sendingRequest"
				:loading="sendingRequest"
				@click="submit"
			/>
		</div>
	</div>
</template>

<script>
import FormGroup from "@/vue/common/form/Group"
import RadioGroup from "@/vue/common/form/RadioGroup";
import Button from "@/vue/common/Button";
import {isDefined} from "@/helper/Value";
import CustomerSendOff from "@/vue/communication/CustomerSendOff";
import ArrowLink from "@/vue/common/ArrowLink";
import MakeAppointment from "@/vue/communication/conversation/message/reply/MakeAppointment";
import CustomerInterested from "@/vue/communication/conversation/CustomerInterested";
import Reply, {ACTION_FOLLOW_UP_APPOINTMENT, ACTION_SENDOFF} from "@/api/communication/conversation/message/Reply";
import flatten from "@/helper/error/Errors";

const FOLLOW_UP_APPOINTMENT = 'appointment';
const FOLLOW_UP_INTERESTED = 'interested';
const FOLLOW_UP_SENDOFF = 'sendoff';

export default {

	components: {
		Button,
		FormGroup,
		RadioGroup,
		CustomerSendOff,
		ArrowLink,
		MakeAppointment,
		CustomerInterested,
	},

	props: {
		message: {
			type: Object,
			required: true,
		}
	},

	data ()
	{
		return {
			followUp: undefined,
			sendOffData: undefined,
			sendingRequest: false,
			makeAppointmentData: undefined,
			actionFollowUpAppointment: ACTION_FOLLOW_UP_APPOINTMENT
		};
	},

	computed: {
		followUpOptions ()
		{
			return [
				{value: FOLLOW_UP_APPOINTMENT, text: 'Ein Folgetermin soll stattfinden'},
				{value: FOLLOW_UP_INTERESTED, text: 'Interesse oder Zusage mitteilen'},
				{value: FOLLOW_UP_SENDOFF, text: 'Verabschieden'},
			];
		},
		followUpValid ()
		{
			return isDefined(this.followUp);
		},
		followUpAppointment ()
		{
			return this.followUp === FOLLOW_UP_APPOINTMENT;
		},
		followUpInterested ()
		{
			return this.followUp === FOLLOW_UP_INTERESTED;
		},
		followUpSendoff ()
		{
			return this.followUp === FOLLOW_UP_SENDOFF;
		},
		sendOffValid ()
		{
			return !this.followUpSendoff || isDefined(this.sendOffData);
		},
		makeAppointmentDataValid ()
		{
			return !this.followUpAppointment || isDefined(this.makeAppointmentData);
		},
		dataValid ()
		{
			return this.followUpValid
				&& this.makeAppointmentDataValid
				&& this.sendOffValid;
		}
	},

	methods: {
		async submit ()
		{
			this.sendingRequest = true;

			try
			{
				let action = undefined;

				if (this.followUpSendoff)
				{
					action = ACTION_SENDOFF;
				}

				if (this.followUpAppointment)
				{
					action = ACTION_FOLLOW_UP_APPOINTMENT;
				}

				const reply = new Reply()
					.setMessageId(this.message.id)
					.setAction(action);

				if (this.followUpSendoff)
				{
					reply.setCustomerSendOffData(this.sendOffData);
				}

				if (this.followUpAppointment)
				{
					reply.setMakeAppointmentData(this.makeAppointmentData);
				}

				await reply.call();

				this.$emit('processed');
			}
			catch (e)
			{
				Toast.error(this, flatten(e.errors));
			}

			this.sendingRequest = false;
		}
	}
}
</script>